import getCssProp from 'DOM/getCssProp';

const selectors = {
  shopByFlavor: '.shop-by-flavor',
};

function filterByType(type) {
  $('#flavor-content-slides').slick('slickUnfilter');
  var typeSelector = '[data-slide-product-type="' + type + '"]';
  $('#flavor-content-slides').slick('slickFilter', typeSelector);
}

const getLayoutMode = () => {
  const shopByFlavor = document.querySelector(selectors.shopByFlavor);

  if (!shopByFlavor) return;

  return getCssProp(shopByFlavor, '--layout-mode');
};

$('#flavor-content-slides').on('init', function() {
  var flavorNav = document.querySelector('.internal-flavor-items');

  if (!flavorNav) return;

  if (getLayoutMode() === 'desktop') return;
  
  setTimeout(function() {
    var slideshowFlavorType = flavorNav.querySelector('.active').dataset.productType;
    filterByType(slideshowFlavorType);
  }, 0);
});

$('#flavor-content-slides').slick({
    dots: false,
    infinite: true,
    arrows: false,
    draggable: false,
    swipe: false,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    centerMode: true,
    prevArrow: "<button type='button' class='slick-prev'><svg id='Layer_1' data-name='Arrow Left' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30.94 20.41'><defs><style>.cls-1,.cls-2{fill:none;stroke:#D82435;stroke-miterlimit:10;}.cls-1{stroke-width:1px;}.cls-2{stroke-width:1px;}</style></defs><line class='cls-1' x1='30.94' y1='10.2' x2='0.94' y2='10.2'/><polyline class='cls-2' points='10.41 20.2 0.41 10.21 10.41 0.2'/></svg></button>",
    nextArrow: "<button type='button' class='slick-next'><svg id='Layer_1' data-name='Arrow Right' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30.94 20.41'><defs><style>.cls-1,.cls-2{fill:none;stroke:#D82435;stroke-miterlimit:10;}.cls-1{stroke-width:1px;}.cls-2{stroke-width:1px;}</style></defs><line class='cls-1' y1='10.2' x2='30' y2='10.2'/><polyline class='cls-2' points='20.53 0.2 30.53 10.21 20.53 20.2'/></svg></button>",
    fade: true,
    cssEase: 'cubic-bezier(.38,.71,.5,.93)',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: true,
          swipe: true,
          draggable: true
        }
      }
    ]
});


// Hanldes the open/closing of the .menu-item elements
document.querySelectorAll('#flavor-menu .menu-item').forEach(function(item){
  item.addEventListener('click', function(e){
    e.preventDefault();
    // If this item is already open, return early
    if($(item).hasClass('open')){
      return;
    }

    // Close all
    document.querySelectorAll('#flavor-menu .menu-item').forEach(function(i){
      i.classList.remove('open');
    });

    // Open this item
    item.classList.add('open');
  });
});

// Handles the toggling of the active class on the parent flavor link
document.querySelectorAll('#flavor-menu .menu-item .menu-item-section-title .nav-link-item').forEach(function(item){
  item.addEventListener('click', function(){
    if($(item).hasClass('active')){
      return;
    }

    document.querySelectorAll('#flavor-menu .menu-item .menu-item-section-title .nav-link-item').forEach(function(item){
      item.classList.remove('active');
    });

    item.classList.add('active');

    var flavor = item.dataset.productFlavor;
    var correctSubItem =  $(".menu-item .internal-flavor-items .nav-link-item[data-product-flavor='" + flavor + "']").get(0);
    $('#flavor-content-slides').slick('slickGoTo', correctSubItem.dataset.productIndex);
    correctSubItem.classList.add('active');
  });
});

// Handles the toggling of the active class on each product type
// AND
// directs the slider to the new menu item.
document.querySelectorAll('.menu-item .nav-link-item[data-product-index]').forEach(function(item){
  item.addEventListener('click', function(e){

    document.querySelectorAll('.menu-item .nav-link-item[data-product-index]').forEach(function(item){
      item.classList.remove('active');
    });

    e.preventDefault();

    var index = item.dataset.productIndex;
    var type = item.dataset.productType;

    if (getLayoutMode() === 'desktop') {
      $('#flavor-content-slides').slick('slickGoTo', index);
    } else {
      filterByType(type);
    }

    item.classList.add('active');
  });
});

/**** Custom Selector ****/
$('.custom-variant-quantity-selector select').prettyDropdown({
  height: 45,
  customClass: 'arrow wyld-select',
  width: 246,
});
